import { FormProvider, useForm, UseFormProps, useWatch } from 'react-hook-form';
import FormEditUserRolesHeader from './FormEditUserRolesHeader';
import FormEditUserRolesFooter from './FormEditUserRolesFooter';
import FormEditUserRolesBody from './FormEditUserRolesBody';
import { FormLabelErrorMessage } from '@/components/forms';
import { DEFAULT_FORM_CONFIG } from '@/constants';
import { IHasEmployee } from '@/interfaces';
import { TFormData } from '.';

const VARIABLES = {
  formConfig: {
    ...DEFAULT_FORM_CONFIG,
    defaultValues: {
      roles: {
        permissions: [],
        employee: true,
        root: false
      }
    }
  } as UseFormProps<TFormData>
};

const FormEditUserRoles = ({ employee }: IHasEmployee) => {

  const formMethods = useForm<TFormData>({
    ...VARIABLES.formConfig,
    values: {
      ...VARIABLES.formConfig.defaultValues,
      ...employee
    } as TFormData
  });
  const errorMessage = useWatch({ control: formMethods.control, name: 'errorMessage' });

  return (
    <FormProvider {...formMethods}>
      <FormEditUserRolesHeader />
      <FormEditUserRolesBody />
      <FormLabelErrorMessage errorMessage={errorMessage} />
      <FormEditUserRolesFooter />
    </FormProvider>
  );

};

export default FormEditUserRoles;
